<template>
	<div>
		<div style="cursor:pointer; width: 100%" v-if="!editing " >
			<v-icon class="float-right mt-1 body-2" @click="editing = 1">mdi-pencil</v-icon>
			<p>{{ panelist.tagString }}</p>
		</div>
		<div v-if="editing || !inline">
			<v-icon v-if="inline" class="float-right body-2" @click="editing = 0">mdi-close</v-icon>
			<v-combobox
				class="body-2"
				v-model="selectedTags"
				:items="tags"
				:item-text="'displayName'"
				v-on:input="tagsChanged" 
				multiple 
				chips
			></v-combobox>		
			<v-dialog
				v-model="addTagDialog"
				max-width="290">
				<v-card>
				<v-card-title class="headline">Add new tag?</v-card-title>
				<v-card-text>
				Only add a new tag if you are sure that there is no relevant existing tag.
				</v-card-text>
				<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
				color="green darken-1"
				text
				@click="dontAddTag"
				>
				No
				</v-btn>

				<v-btn
				color="green darken-1"
				text
				@click="doAddTag"
				>
				Yes
				</v-btn>
				</v-card-actions>
				</v-card>
			</v-dialog>
		</div>
	</div>
</template>

<script>

import Vuex from 'vuex'

export default {
	name: "Tags",
	props: {
		'panelist': { type: Object},  
		'saveOnChange': { default: false},
		'inline': {default: false}
	},
	data: () => ({
		editing: false,
		addTagDialog: false,
		selectedTags: [] 
    }),
	computed: {
		...Vuex.mapState({
			view: state => state.auth.view,
			tags: function(state){
				if( !state[state.auth.view] ){ return [] }
				else{
					return state[state.auth.view].tags
				}
			} 
		}),
		// tagString(){
		// 	return this.selectedTags.map(tag => tag.displayName).join(", ")
		// }
	},
	created(){
		if( !this.tags.length ){
			this.$store.dispatch("bindTags" )
		}
	},
	watch: {
		tags: {
			handler: function(){
				// the panelist tags are just keys and we want to be able to read the tag objects properly
				// this retrieves the tag objects and sets the panelist.tags property to an array of those				
				if( this.panelist.tags ){
					let allTags = this.tags;
					let tagObjects = [];
					this.panelist.tags.forEach( function(tag){
						if( !tag ){ return }
						tagObjects.push( allTags.find( t => t.id == tag ) ) 
					})
					this.selectedTags = tagObjects;
				}
				else{
					this.panelist.tags = [];
					this.selectedTags = [];
				}
			}, 
			immediate: true
		},
		// tagString(tagString){
		// 	this.panelist.tagString = tagString;
		// }
	},
	methods: {
		tagsChanged: function(tags){
			let tag = tags.find( t => typeof t == 'string');
			if( tag ){
				this.addTagDialog = 1;
			}
			else{
				this.save();
			}
		},
		dontAddTag: function(){
			this.selectedTags = this.selectedTags.filter( tag => typeof tag !== 'string');
			this.addTagDialog = 0;
		},
		doAddTag: function(){
			let self = this;
			let newTagString = this.selectedTags.find( tag => typeof tag == 'string' );
			if( newTagString ){				
				let newTagObject = { displayName: newTagString, name: newTagString.toLowerCase().split(" ").join("-") }
				self.$store.dispatch("addDoc", { 
					collection: "tags", 
					data: newTagObject
				}).then( function(ref ){
					self.$store.dispatch("bindAnything", {id: ref.id, collection: "tags", then: "SET_ANYTHING", reference: "tags" } )
					newTagObject.id = ref.id;
					self.selectedTags = self.selectedTags.filter( tag => typeof tag !== 'string');
					self.selectedTags.push( newTagObject )
					self.panelist.tags.push( newTagObject.id )
					self.addTagDialog = 0;
					self.save();
				})
			}
		},
		save: function(){
			let tags = this.selectedTags.map( tag => tag.id )
			this.$store.dispatch("updateDoc", {
				data: {tags: tags},
				doc: "users/" + this.panelist.id,
				action: "update",
			} )
			this.$emit("updatedTags", this.panelist, tags )
		}
	} 
}
</script>